import themeStore from 'theme/store'

// export function extendStore (original) {
export function extendStore () {
  return themeStore()
}
